import { render, staticRenderFns } from "./QuizActivityCatalogsSwitch.vue?vue&type=template&id=f992a63a&"
import script from "./QuizActivityCatalogsSwitch.vue?vue&type=script&lang=js&"
export * from "./QuizActivityCatalogsSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports